// extracted by mini-css-extract-plugin
module.exports = {"TextSection":"TextSection_TextSection__Zlgx6","column":"TextSection_column__ioh9F"};